module.exports = __webpack_public_path__ + "img/grey_trigger.7e3e4e9d.svg";